function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Button/Oval Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Notifications---1820x1024",
  transform: "translate(-1402.000000, -508.000000)"
}, React.createElement("g", {
  id: "Notifications",
  transform: "translate(1370.000000, 100.000000)"
}, React.createElement("g", {
  transform: "translate(16.000000, 24.000000)",
  id: 4
}, React.createElement("g", {
  transform: "translate(0.000000, 360.000000)"
}, React.createElement("g", {
  id: "Button/Oval",
  transform: "translate(16.000000, 24.000000)"
}, React.createElement("g", {
  id: "Button/Back"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#30A3FF",
  cx: 20,
  cy: 20,
  r: 20
}), React.createElement("g", {
  id: "Icons/Privacy",
  transform: "translate(12.000000, 12.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "noun_Shield_1985493",
  transform: "translate(3.500000, 2.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M4.5,11.9220779 C0.39375,10.3012987 0.028125,6.77922078 0.0421875,3.66233766 L6.46875,10.8 C5.8640625,11.2675325 5.203125,11.6571429 4.5,11.9220779 Z M8.9296875,1.88571429 C8.9296875,2.13506494 8.94375,2.38441558 8.94375,2.63376623 C8.971875,4.25454545 9,6.04675325 8.5078125,7.66753247 L2.7421875,1.27792208 C3.3890625,0.966233766 3.9796875,0.545454545 4.5,0.0155844156 C5.709375,1.23116883 7.1296875,1.82337662 8.9296875,1.88571429 Z M0.0703125,1.88571429 C0.7734375,1.87012987 1.490625,1.72987013 2.165625,1.51168831 L8.296875,8.30649351 C7.9734375,9.11688312 7.509375,9.83376623 6.91875,10.4103896 L0.05625,2.80519481 L0.05625,2.63376623 C0.05625,2.38441558 0.0703125,2.11948052 0.0703125,1.88571429 Z",
  id: "Combined-Shape"
})))))))))));

var SvgUpdate = function SvgUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/update.d197bb5c.svg";
export { ForwardRef as ReactComponent };